import { render } from "./TableTabletFormComponent.vue?vue&type=template&id=738597c4"
import script from "./TableTabletFormComponent.vue?vue&type=script&lang=js"
export * from "./TableTabletFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__